import { render, staticRenderFns } from "./countryComponent.vue?vue&type=template&id=2a675680"
import script from "./countryComponent.vue?vue&type=script&lang=js"
export * from "./countryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports